<script lang="ts">
	import Minus from '$lib/assets/images/icons/minus.svg?component';
	import Plus from '$lib/assets/images/icons/plus.svg?component';
	import __ from '$lib/stores/TranslationStore';
	import { fly } from 'svelte/transition';
	import NumberInput from './NumberInput.svelte';
	import { getContext, onMount } from 'svelte';
	import { useStepFieldUpdater } from '../../Stepper/stepper';

	export let name: string;

	const hash = getContext<symbol>('stepHash');
	const { value: ageCount, updateValue, step } = useStepFieldUpdater<string>(hash, 'ageCount');

	$: items = Array(parseInt($ageCount || '1'));

	function increment() {
		updateCounter((count) => {
			if (count >= 4) {
				return 4;
			}
			return ++count;
		});
	}

	function decrement() {
		updateCounter((count) => {
			if (count <= 1) {
				return 1;
			}
			return --count;
		});
	}

	function updateCounter(modifier: (count: number) => number) {
		updateValue((ageCount, step) => {
			const data = step.data;
			let count = parseInt(ageCount);
			if (Object.is(NaN, count) || !count) {
				count = 1;
			} else {
				count = modifier(count);
			}

			return {
				age_1: data.age_1 || '',
				age_2: count >= 2 ? data.age_2 || '' : '',
				age_3: count >= 3 ? data.age_3 || '' : '',
				age_4: count === 4 ? data.age_4 || '' : '',
				ageCount: String(count)
			};
		});
	}

	onMount(() => {
		updateValue((_, step) => ({ ageCount: step.data.ageCount || '1' }));
	});
</script>

<section class="flex w-full flex-col gap-6 md:w-[290px]">
	<div class="flex flex-row justify-between gap-x-2">
		<button
			class="flex h-16 w-16 shrink-0 items-center justify-center rounded-md bg-secondary text-white"
			on:click={decrement}
		>
			<Minus class="stroke-white" />
		</button>
		<div class="relative w-20 grow text-5xl">
			<input
				class="w-full border-b-[1px] border-dark text-center text-transparent caret-dark outline-none"
				type="number"
				min="1"
				max="4"
				readonly
				value={$ageCount}
			/>
			{#key $ageCount}
				<p
					transition:fly={{ y: -20 }}
					class="pointer-events-none absolute top-[7px] w-full text-center"
				>
					{$ageCount}
				</p>
			{/key}
		</div>
		<button
			class="flex h-16 w-16 shrink-0 items-center justify-center rounded-md bg-secondary text-white"
			on:click={increment}
		>
			<Plus class="stroke-white" />
		</button>
	</div>
	<div class="flex flex-col gap-7">
		{#each items as _, index}
			<div transition:fly={{ y: 20 }}>
				<NumberInput
					focusOnMount={index == 0}
					type="number"
					name="age_{index + 1}"
					label={$__('Idade') + ' ' + (index + 1)}
				>
					<div class="-ml-1 cursor-text rounded-sm bg-secondary text-white" slot="after">
						<p class="m-0 select-none px-[2px] py-[3px] leading-none">anos</p>
					</div>
				</NumberInput>
			</div>
		{/each}
	</div>
</section>
